import styled from "styled-components"
import Text from "../../atoms/Text"
import SelectableButton from "../../atoms/SelectableButton"

const Container = styled.div`
  width: 100%;
`
const LabelWrapper = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: 4px;
`
const RequiredCircle = styled.div`
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.status.error};
`
const ButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
`
const GenderSelector = ({selected, onSelect}) => {
  const options = [
    {name: '아들', value: 'male'}, 
    {name: '딸', value: 'female'}
  ]

  return (
    <Container>
      <label>
        <LabelWrapper>
          <Text as="label" variant="body2" weight="medium">아이 성별</Text>
          <RequiredCircle aria-label="필수 입력 항목"/>
        </LabelWrapper>
      </label>
      <ButtonWrapper>
        {options.map((opt) => (
        <SelectableButton
          key={opt.name}
          label={opt.name}
          $isActive={selected === opt.value}
          onClick={() => onSelect(opt.value)}
        />
      ))}
      </ButtonWrapper>
      
    </Container>
  )
}

export default GenderSelector
